import { flattenUrls, URLS } from '@/lib/consts';
import type { CTA } from '@/lib/types';
import { formatForLabel } from '@/lib/utils';

/*
 * Footer Section Identifier
 */
export const FOOTER_SECTION_ID = 'footer';

export const CTAS: CTA[] = [
  {
    label: 'START WITH A FLOOR PLAN',
    href: URLS.OUR_FLOOR_PLANS,
    icon: 'layout',
    variant: 'secondary',
  },
  {
    label: 'TOUR OUR HOMES',
    href: URLS.OUR_HOMES,
    icon: 'home',
    variant: 'default',
  },
];

export const URLS_LIST: CTA[] = flattenUrls(URLS, ([key, value]) => {
  return {
    label: formatForLabel(key),
    href: value,
    variant: 'link',
  };
});
